import { baseReportUrl } from 'environments'
import { createActions } from 'helpers/actions'
import entityNames from 'options/entityNames'

export default createActions(entityNames.cardinalReport, {
  basePath: 'report/adminReports',
  baseUrl: baseReportUrl,
})
